var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-down-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.574 7.699c-0.568-0.568-1.489-0.568-2.057 0l-13.517 13.517-13.517-13.517c-0.568-0.568-1.489-0.568-2.057 0s-0.568 1.489 0 2.057l14.546 14.545c0.273 0.273 0.643 0.426 1.028 0.426s0.756-0.153 1.028-0.426l14.545-14.545c0.568-0.568 0.568-1.489 0-2.057z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "account-box",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    style: {
      fill: "var(--color1, #e0e0e0)"
    },
    d: "M4.667 6.667v18.667c0 1.467 1.187 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667v-18.667c0-1.467-1.2-2.667-2.667-2.667h-18.667c-1.48 0-2.667 1.2-2.667 2.667zM20.667 12c0 2.213-1.787 4-4 4s-4-1.787-4-4c0-2.213 1.787-4 4-4s4 1.787 4 4zM8.667 22.667c0-2.667 5.333-4.133 8-4.133s8 1.467 8 4.133v1.333h-16v-1.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    style: {
      fill: "var(--color1, #e0e0e0)"
    },
    d: "M27.333 5.333h-21.333c-1.467 0-2.653 1.2-2.653 2.667l-0.013 16c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-16c0-1.467-1.2-2.667-2.667-2.667zM27.333 10.667l-10.667 6.667-10.667-6.667v-2.667l10.667 6.667 10.667-6.667v2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    style: {
      fill: "var(--color1, #e0e0e0)"
    },
    d: "M24.667 10.667h-1.333v-2.667c0-3.68-2.987-6.667-6.667-6.667s-6.667 2.987-6.667 6.667v2.667h-1.333c-1.467 0-2.667 1.2-2.667 2.667v13.333c0 1.467 1.2 2.667 2.667 2.667h16c1.467 0 2.667-1.2 2.667-2.667v-13.333c0-1.467-1.2-2.667-2.667-2.667zM16.667 22.667c-1.467 0-2.667-1.2-2.667-2.667s1.2-2.667 2.667-2.667c1.467 0 2.667 1.2 2.667 2.667s-1.2 2.667-2.667 2.667zM20.8 10.667h-8.267v-2.667c0-2.28 1.853-4.133 4.133-4.133s4.133 1.853 4.133 4.133v2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "wallet",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color2, #24cca7)"
    },
    d: "M3.755 7.619l16.211-4.537-0.858-1.779c-0.562-1.157-1.932-1.634-3.060-1.058l-14.513 7.375h2.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color2, #24cca7)"
    },
    d: "M24.813 3.048c-0.195 0-0.391 0.029-0.586 0.087l-15.012 4.484h18.431l-0.693-2.779c-0.266-1.083-1.163-1.793-2.14-1.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color3, #4a56e2)"
    },
    d: "M28.36 8.573h-26.559c-0.568 0-1.074 0.26-1.405 0.67-0.151 0.189-0.266 0.406-0.331 0.645-0.040 0.15-0.065 0.307-0.065 0.467v19.862c0 0.984 0.805 1.783 1.797 1.783h26.559c0.992 0 1.797-0.799 1.797-1.783v-4.973h-10.662c-1.685 0-3.055-1.358-3.055-3.030v-3.965c0-0.82 0.331-1.565 0.866-2.111 0.474-0.485 1.11-0.813 1.822-0.895 0.119-0.014 0.241-0.021 0.363-0.021h10.665v-4.867c0.004-0.984-0.801-1.783-1.793-1.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color3, #4a56e2)"
    },
    d: "M31.414 16.926c-0.18-0.164-0.392-0.289-0.629-0.371-0.183-0.061-0.377-0.096-0.582-0.096h-10.712c-0.992 0-1.797 0.799-1.797 1.783v3.968c0 0.984 0.805 1.783 1.797 1.783h10.712c0.205 0 0.399-0.036 0.582-0.096 0.237-0.078 0.449-0.207 0.629-0.371 0.359-0.324 0.586-0.795 0.586-1.316v-3.968c0-0.521-0.226-0.991-0.586-1.316zM23.243 20.581c0 0.492-0.402 0.891-0.898 0.891h-0.596c-0.496 0-0.898-0.399-0.898-0.891v-0.592c0-0.285 0.133-0.538 0.345-0.699 0.154-0.118 0.345-0.192 0.553-0.192h0.596c0.496 0 0.898 0.399 0.898 0.891v0.592z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 38 38"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Zm9.933 21.36v8.195H9.1V18.627H5L18.667 6.333l13.666 12.294h-4.1v10.928H21.4V21.36h-5.467Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "diagram",
    viewBox: "0 0 38 38"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Zm23.5 16.555c1.283 0 2.333-1.1 2.333-2.444 0-1.344-1.05-2.444-2.333-2.444-1.283 0-2.333 1.1-2.333 2.444 0 .22.023.428.081.623l-4.141 4.351A1.973 1.973 0 0 0 22.5 19c-.21 0-.42.024-.607.085l-2.975-3.116c.059-.196.082-.416.082-.636 0-1.344-1.05-2.444-2.333-2.444-1.284 0-2.334 1.1-2.334 2.444 0 .22.024.44.082.636l-5.32 5.561a1.9 1.9 0 0 0-.595-.086c-1.283 0-2.333 1.1-2.333 2.445 0 1.344 1.05 2.444 2.333 2.444 1.283 0 2.333-1.1 2.333-2.444 0-.22-.023-.428-.081-.623l5.308-5.574c.187.061.397.086.607.086.21 0 .42-.025.606-.086l2.975 3.117a2.256 2.256 0 0 0-.081.635c0 1.345 1.05 2.445 2.333 2.445 1.283 0 2.333-1.1 2.333-2.445 0-.22-.023-.44-.081-.635l4.153-4.339c.187.061.385.085.595.085Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "currency",
    viewBox: "0 0 38 38"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Zm9.752 15.599c0 1.182.909 1.94 3.733 2.675 2.825.734 5.848 1.941 5.848 5.475 0 2.55-1.928 3.957-4.355 4.417v2.675h-3.733v-2.7c-2.389-.51-4.43-2.04-4.578-4.765h2.737c.137 1.468 1.145 2.612 3.708 2.612 2.75 0 3.36-1.368 3.36-2.227 0-1.157-.623-2.252-3.733-2.998-3.472-.834-5.849-2.265-5.849-5.14 0-2.4 1.942-3.968 4.355-4.491V8.444h3.733v2.725c2.6.635 3.907 2.6 3.994 4.741h-2.75c-.074-1.555-.895-2.613-3.11-2.613-2.103 0-3.36.946-3.36 2.302Z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_cancel",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.768 16l13.866-13.866c0.488-0.488 0.488-1.28 0-1.768s-1.28-0.488-1.768 0l-13.866 13.866-13.866-13.866c-0.488-0.488-1.28-0.488-1.768 0s-0.488 1.28 0 1.768l13.866 13.866-13.866 13.866c-0.488 0.488-0.488 1.28 0 1.768 0.244 0.244 0.564 0.366 0.884 0.366s0.64-0.122 0.884-0.366l13.866-13.866 13.866 13.866c0.244 0.244 0.564 0.366 0.884 0.366s0.64-0.122 0.884-0.366c0.488-0.488 0.488-1.28 0-1.768l-13.866-13.866z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0c2.761 0 5 2.239 5 5 0 1.126-0.372 2.164-1 3l-2 2-7-7 2-2c0.836-0.628 1.874-1 3-1zM2 23l-2 9 9-2 18.5-18.5-7-7-18.5 18.5zM22.362 11.362l-14 14-1.724-1.724 14-14 1.724 1.724z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_pencil2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20l4-2 14-14-2-2-14 14-2 4zM9.041 27.097c-0.989-2.085-2.052-3.149-4.137-4.137l3.097-8.525 4-2.435 12-12h-6l-12 12-6 20 20-6 12-12v-6l-12 12-2.435 4z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "bin",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10v20c0 1.1 0.9 2 2 2h18c1.1 0 2-0.9 2-2v-20h-22zM10 28h-2v-14h2v14zM14 28h-2v-14h2v14zM18 28h-2v-14h2v14zM22 28h-2v-14h2v14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 4h-6.5v-2.5c0-0.825-0.675-1.5-1.5-1.5h-7c-0.825 0-1.5 0.675-1.5 1.5v2.5h-6.5c-0.825 0-1.5 0.675-1.5 1.5v2.5h26v-2.5c0-0.825-0.675-1.5-1.5-1.5zM18 4h-6v-1.975h6v1.975z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "remove",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 8l-5 5-5-5-3 3 5 5-5 5 3 3 5-5 5 5 3-3-5-5 5-5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.16c4e22a84c8f885e8d2b034626915d2.svg";
export { ForwardRef as ReactComponent };